var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 1.75H2.25C1.97344 1.75 1.75 1.97344 1.75 2.25V13.75C1.75 14.0266 1.97344 14.25 2.25 14.25H7.875C7.94375 14.25 8 14.1938 8 14.125V13.25C8 13.1812 7.94375 13.125 7.875 13.125H2.875V2.875H13.125V7.875C13.125 7.94375 13.1812 8 13.25 8H14.125C14.1938 8 14.25 7.94375 14.25 7.875V2.25C14.25 1.97344 14.0266 1.75 13.75 1.75ZM10.2078 9.36563L11.0234 8.55C11.04 8.5334 11.0515 8.51249 11.0567 8.48965C11.0619 8.46682 11.0607 8.44298 11.053 8.42084C11.0454 8.3987 11.0316 8.37915 11.0134 8.36442C10.9952 8.34969 10.9732 8.34036 10.95 8.3375L8.14688 8.00937C8.06719 8 7.99844 8.06719 8.00781 8.14844L8.33594 10.9516C8.34844 11.0547 8.475 11.0984 8.54844 11.025L9.36719 10.2063L13.3703 14.2094C13.4187 14.2578 13.4984 14.2578 13.5469 14.2094L14.2094 13.5469C14.2578 13.4984 14.2578 13.4187 14.2094 13.3703L10.2078 9.36563Z",
  fill: "#2260E5"
});

function SvgUrl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.878ef1ff9f1e33b7c1d0992537c01f10.svg";
export { ForwardRef as ReactComponent };